import axios from "axios";
import { BASE_URL } from "./appConst";
import { login } from "../reducers/authSlice";
import { toast } from "react-toastify";


export const loginUser =
  (username: string, password: string) =>
  async (dispatch) => {
    try {
      const response = await axios.post(`${BASE_URL}/login`, {
        username,
        password,
      });

      if(response.data.message.toLowerCase() ==="success") {
        const token = response.data.data.response.AccessToken;
        const refreshToken = response.data.data.response.RefreshToken;
        dispatch(login({token, refreshToken}));
        return token;
      }

    } catch (error: any) {
      toast.error(error.response.data.message.toUpperCase());
      console.error('Login failed!', error);
      throw error;
    }
  };


export const LoginAPI = async (username: string, password: string) => {
  try {
    const response = await axios.post(`${BASE_URL}/login`, {
      username,
      password,
    });
    return response.data.data;
  } catch (error) {
    console.log(error);
    return {
      msg: "error occured",
    };
  }
};

export const forgotPassword = async (email: string) => {
  const response = await axios.post(`${BASE_URL}/forgot-password`, {
    email
  });

  return response.data;
};

export const resetPassword = async (email: string, confirmationCode: string, newPassword: string) => {

  const response = await axios.post(`${BASE_URL}/reset-password`, {
    email,
    confirmationCode,
    newPassword,
  });

  return response.data;
}
